<div class="app-map">
  <div class="app-map__header">
    <h2 class="app-map__header__title">Encuéntranos</h2>
  </div>

  <div class="container">
    <div class="app-map__search">
      <div class="d-flex flex-column flex-lg-row justify-content-between">
        <div class="d-flex flex-column flex-md-row">
          <button class="app-button mb-2" (click)="myPosition()">
            <span class="material-icons"> location_on </span>
            Buscar Cerca
          </button>
          <div
            class="app-input-search ml-md-4 mb-2"
            [ngClass]="{
              'app-input-search--focus': searchStartStatus.focus,
              'app-input-search--has-content': !!searchStartModel,
              'app-input-search--complete': searchStartStatus.complete
            }"
          >
            <span class="material-icons app-input-search__icon"> search </span>
            <input
              type="text"
              class="app-input-search__element"
              name="Center"
              (focus)="focus(searchStartStatus)"
              (input)="changeSearchStart()"
              [(ngModel)]="searchStartModel"
              (blur)="blur(searchStartStatus)"
              placeholder="Buscar ubicación partida"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="off"
              type="text"
              (keydown.enter)="$event.preventDefault()"
              #searchStart
            />
          </div>
          <div
            class="app-input-search app-input-search--secondary ml-md-4 mb-2"
            [ngClass]="{
              'app-input-search--focus': searchEndStatus.focus,
              'app-input-search--has-content': !!searchEndModel,
              'app-input-search--complete': searchEndStatus.complete
            }"
          >
            <span class="material-icons app-input-search__icon"> search </span>
            <input
              type="text"
              class="app-input-search__element"
              (focus)="focus(searchEndStatus)"
              (input)="changeSearchEnd()"
              [(ngModel)]="searchEndModel"
              (blur)="blur(searchEndStatus)"
              placeholder="Buscar ubicación destino"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="off"
              type="text"
              (keydown.enter)="$event.preventDefault()"
              #searchEnd
            />
          </div>
        </div>
        <div>
          <button
            class="app-button app-button--secondary ml-lg-4"
            [disabled]="stations.length === 0 || !latitudeStart || !latitudeEnd"
            (click)="exportStations()"
          >
            <span class="material-icons"> downloading </span>
            <span class="app-button__underline"> Descargar Data Grifos </span>
          </button>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row app-map__content">
      <div class="app-map__content__filters">
        <div
          class="app-map__content__filters__title"
          (click)="showFilterMobile()"
        >
          <img [src]="iconFilter" alt="Filtrar por" />
        </div>
        <div
          class="app-map__content__filters__list"
          [ngClass]="{ 'app-map__content__filters__list--active': showFilters }"
        >
          <div
            *ngFor="let filter of filters; index as i"
            class="app-map__content__filters__filter"
            [ngClass]="{
              'app-map__content__filters__filter--active': filter.selected
            }"
            (click)="selectFilter(filter)"
          >
            <span class="app-map__content__filters__filter__name">
              {{ filter.name }}
            </span>
            <img
              class="
                app-map__content__filters__filter__icon
                app-map__content__filters__filter__icon--active
              "
              [src]="filter.selected ? filter.iconactive : filter.iconinactive"
              [alt]="filter.name"
            />
          </div>

          <div
            class="
              d-flex
              justify-content-center
              app-map__content__filters__list__button
              d-md-none
            "
          >
            <button class="app-button" (click)="showFilterMobile()">
              Cerrar
            </button>
          </div>
        </div>
      </div>
      <div class="app-map__content__map">
        <agm-map
          *ngIf="origin"
          [latitude]="origin.lat"
          [zoom]="zoom"
          [longitude]="origin.lng"
          (mapClick)="mapClick($event)"
          (mapReady)="mapReady($event)"
        >
          <agm-direction
            [origin]="routeOrigin"
            [destination]="routeDestination"
            [travelMode]="travelMode"
            *ngIf="routeOrigin && routeDestination"
            [renderOptions]="renderOptions"
            (sendInfoWindow)="responseRoute($event)"
            (onResponse)="responseRoute($event)"
          ></agm-direction>

          <agm-marker
            *ngFor="let station of stations; index as i"
            [latitude]="station.latitude"
            (markerClick)="clickedMarker(infowindow, i)"
            [longitude]="station.longitude"
            [iconUrl]="hostImages + iconStation "
            [markerDraggable]="false"
          >
            <agm-info-window #infowindow>
              <app-marker-info [data]="station"> </app-marker-info>
            </agm-info-window>
          </agm-marker>
          <agm-marker
            *ngIf="latitudeStart && longitudeStart"
            [latitude]="latitudeStart"
            [longitude]="longitudeStart"
            [iconUrl]="pointStart"
            [zIndex]="100"
          ></agm-marker>
          <agm-marker
            *ngIf="latitudeEnd && longitudeEnd"
            [latitude]="latitudeEnd"
            [longitude]="longitudeEnd"
            [iconUrl]="pointEnd"
            [zIndex]="101"
          ></agm-marker>
        </agm-map>
      </div>
    </div>
  </div>
</div>
